import { Box, Button, Card, Input, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import './styles.css';

import SendIcon from '@mui/icons-material/Send';
import CachedIcon from '@mui/icons-material/Cached';
import TypingAnimation from "../typingAnimation";
import { POST_DATA, SalvarLogErro } from "../../services/API";
import { useDispatch, useSelector } from "react-redux";

import { v4 as uuidv4 } from 'uuid';

import Swal from "sweetalert2";
import { setMessagesAssistant } from "../../context/assistantSlice";
import { transformDatePtBR } from "../../utils";
import { useLocation } from "react-router-dom";

const Chat = () => {
    const dispatch = useDispatch();
    const chatContainerRef = useRef(null);
    const location = useLocation();

    const dados = useSelector((state) => state.assistant.dados);

    const [input, setInput] = useState("");
    const [loadingResponse, setLoadingResponse] = useState(false);

    function scrollToBottom() {
        chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }

    const sendMessage = async () => {

        if (dados === null || !dados?.assistantId) {
            Swal.fire({
                title: "Aviso!",
                text: "Favor selecionar um assitente para iniciar o chat",
                icon: "warning"
            });
            return;
        }

        if (!input.trim()) return;

        const mensagens = [...dados.messages];

        let mensagem = input;

        if(location.state?.agente){
            mensagem = `${location.state?.agente} - ` + input;
        }

        mensagens.push({ sender: "user", text: input, time: transformDatePtBR(new Date()) });

        dispatch(setMessagesAssistant(mensagens));

        setInput("");

        //Enviar e aguardar retorno da API
        try {
            setLoadingResponse(true);

            const obj = {
                messageId: uuidv4(),
                senderName: "Next Run",
                phone: '5555999999999', //dados.externalReference,
                assistenteId: location.state?.id,
                assistant: dados.assistantId,
                typeMessage: 1,
                text: input
            };

            const response = await POST_DATA('RequestOpenIA/ReceiveMessage', obj);

            const novasMensagens = [...mensagens, { sender: "assistent", text: response.data?.text ? response.data?.text : response.data, time: transformDatePtBR(new Date()) }];

            dispatch(setMessagesAssistant(novasMensagens));

            setLoadingResponse(false);
        }
        catch (err) {
            setLoadingResponse(false);
            SalvarLogErro('sendMessage chat', err);
        }


        scrollToBottom();
    };

    useEffect(() => {
        if (chatContainerRef.current) {
            chatContainerRef.current.scrollTo({
                top: chatContainerRef.current.scrollHeight,
                behavior: "smooth"
            });
        }
    }, [dados?.messages]); // Dispara a rolagem sempre que `messages` mudar

    return (
        <Box>
            {/* Chat */}
            <Card className="w p-4 flex flex-col scroll-smooth bg-white dark:bg-gray-800 transition-colors">
                <Box className="w flex h-12 flex-row justify-between">
                    <Typography className="text-gray-700 dark:text-gray-300 mb-2">Chat de Teste por Simulação de Bot</Typography>

                    <CachedIcon className="cursor-pointer" onClick={() => dispatch(setMessagesAssistant([
                        { sender: "assistant", text: "Bem-vindo! Como posso te ajudar?", time: transformDatePtBR(new Date()) },
                    ]))} />

                </Box>
                <Card className="chat-container p-4 w-full mx-auto bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded dark:text-white" ref={chatContainerRef} style={{ overflowY: "auto", maxHeight: "400px" }}>
                    {dados?.messages?.map((msg, index) => {
                        return <div
                            key={`msg-${index}`}
                            className={`${(msg.sender === 'user' ? 'message user' : 'message assistant')} `}
                            style={{ whiteSpace: "pre-line" }}
                        >
                            <span dangerouslySetInnerHTML={{ __html: msg.text?.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>") }} />

                            <div className="w relative mt-1 mb-4">
                                <span className="absolute right-0 text-xs">
                                    {msg.time}
                                </span>
                            </div>
                        </div>
                    })}
                    {
                        loadingResponse && (
                            <div
                                className={`message assistant min-w-20 mt-1 flex flex-col justify-center items-center`}
                            >
                                <TypingAnimation />
                            </div>)
                    }
                </Card>
                <div className="flex mt-4 justify-between gap-2">
                    <Input
                        fullWidth
                        value={input}
                        className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded dark:bg-gray-700 dark:text-white"
                        onChange={(e) => setInput(e.target.value)}
                        disabled={loadingResponse}
                        placeholder="Digite seu texto"
                        onKeyDown={async (e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                await sendMessage();
                            }
                        }}
                    />
                    <Button disabled={loadingResponse} onClick={() => sendMessage()}><SendIcon /></Button>
                </div>
            </Card>
        </Box>
    )

}

export default Chat;